var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsertComment24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#4132b4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20,2H4A2.006,2.006,0,0,0,2,4V16a2.006,2.006,0,0,0,2,2H18l4,4V4A2.006,2.006,0,0,0,20,2ZM17,14H7a1,1,0,0,1,0-2H17a1,1,0,0,1,0,2Zm0-3H7A1,1,0,0,1,7,9H17a1,1,0,0,1,0,2Zm0-3H7A1,1,0,0,1,7,6H17a1,1,0,0,1,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertComment24Px);
export default __webpack_public_path__ + "static/media/insert_comment-24px.1103853eda8c56d1cb62edc9a028c8f0.svg";
export { ForwardRef as ReactComponent };